import { Topping, ToppingValue } from "~/common/props/orchestrator";
import { ToppingValueDto } from "~/modules/Product/Product.type";
import type { DBProduct, ShoppingCart } from "@commons-monorepo/index";
import {
  priceCalculator,
  priceWithWholesale,
  getDbProductId,
} from "@commons-monorepo/index";

const mapToppings = (toppings?: Topping[]): ToppingValueDto[] => {
  const returnToppings: any = [];
  toppings?.forEach((topping: Topping, index: number) => {
    let toppingDto = {};
    topping.values.forEach((value: ToppingValue) => {
      toppingDto = {
        additionalPrice: value.additionalPrice,
        parentIndex: index,
        toppingName: topping.name,
        toppingId: topping.id,
        value: value.value,
      };
      returnToppings.push(toppingDto);
    });
  });
  return returnToppings;
};

export const mapProductsFromShoppingCart = (
  response: ShoppingCart,
): DBProduct[] => {
  const products = response?.products || [];
  return products.map((product: any) => {
    const toppings = mapToppings(product.toppings);
    const productData = {
      id: product.productId,
      quantity: product.units,
      variationId: product.variationId,
      toppings: toppings,
      price:
        product.unitPriceWithDiscount ||
        product.unitPrice ||
        priceCalculator(product, toppings),
      wholesalePrice: priceWithWholesale(product, toppings),
      wholesale: product.wholesale,
      chatId: response.additionalInformation?.chatId,
    };
    return {
      ...productData,
      dbId: getDbProductId(productData),
    };
  });
};
